export const UX4_PRIMARY_ORANGE = "#FF5200";
export const UX4_POP_PRIMARY = "#CAFE33";
export const UX4_POP_TEXT_PRIMARY = "#0B1B17";
